export default "__VITE_ASSET__A$p5Yef$__"